(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__brumeUpgrade) return;
    window.__brumeUpgrade = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-brume-upgrade]');
      if (!b) return;
      b.disabled = true; b.textContent = 'Un instant…';
      var updates = {};
      updates[b.getAttribute('data-unit')] = 0;
      updates[b.getAttribute('data-cure')] = parseInt(b.getAttribute('data-qty'), 10) || 1;
      var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.href = root + 'cart'; })
        .catch(function () { b.disabled = false; b.textContent = 'Passer à la cure · 44,90 €'; });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
